import React from 'react';
import { Query, useMutation } from 'react-apollo';
import MaterialTable from 'material-table';
import { GET_CATEGORIES, EDIT_CATEGORY, ADD_CATEGORY } from 'graphql/payments';

const categoryLookup = {
  ncf: 'Non client facing',
  cf: 'Client facing',
  cb: 'Completion Bonus',
  misc: 'Misc',
};

const Categories = ({ }) => {
  const [updateCategory] = useMutation(EDIT_CATEGORY);
  const [addCategory] = useMutation(ADD_CATEGORY);

  const columns = [
    { title: 'Name', field: 'label', required: true },
    { title: 'Category', field: 'type', lookup: categoryLookup, required: true },
  ];

  return (
    <Query query={GET_CATEGORIES} fetchPolicy={'cache-and-network'}>
      {({ data, loading, refetch }) => {

        const onRowAdd = (data) => {
          if (!data.label || !data.type) return Promise.reject('All fields are required')
          return addCategory({
            variables: { data }
          }).then(() => refetch());
        }

        const onRowUpdate = (newData, oldData) => {
          return updateCategory({
            variables: {
              id: oldData.id,
              data: {
                label: newData.label,
                type: newData.type
              }
            }
          });
        }

        const onRowDelete = (data) => {
          return updateCategory({
            variables: {
              id: data.id,
              data: { deleted: true }
            }
          }).then(() => refetch());
        }

        return (
          <MaterialTable
            columns={columns}
            data={data?.payment_categories}
            isLoading={loading}
            options={{
              pageSize: 10,
              addRowPosition: 'first'
            }}
            editable={{
              onRowAdd,
              onRowUpdate,
              onRowDelete
            }}
          />
        )
      }}
    </Query>
  )
}

export default Categories;